const Separator = () => {
  return (
    <div>
      <hr style={{ border: "1px dashed black" }} />
    </div>
  );
};

export default Separator;
